import React from 'react';
import { Container, Typography, Box, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import GppBadIcon from '@mui/icons-material/GppBad';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const UnauthorizedPage = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="sm" sx={{ mt: 10 }}>
            <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
                <GppBadIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Access Denied!
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                    You do not have permission to view this page.
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                    <Button 
                        variant="outlined" 
                        startIcon={<ArrowBackIcon />} 
                        onClick={() => navigate(-1)}
                    >
                        Go Back
                    </Button>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        onClick={() => navigate('/')}
                    >
                        Go Home
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default UnauthorizedPage;